import { aiText } from "../i18n/aiText";
import { useLocale } from "../lib/locale-context";

/**
 * "· AI" after a person's name when the thing shown was done through an AI assistant (`actorChannel === "ai"`; contract
 * 0.10.62). Visible text "AI"; screen readers hear "done through an AI assistant". Renders nothing for a human action.
 */
export function AiBadge({ channel }: { channel: string | null | undefined }) {
  const locale = useLocale();
  if (channel !== "ai") return null;
  const label = aiText("badgeLabel", locale);
  return (
    <>
      {" · "}
      <span className="gf-ai-badge" title={label} data-testid="ai-badge">
        <span aria-hidden="true">{aiText("badge", locale)}</span>
        <span className="vh">{label}</span>
      </span>
    </>
  );
}
